export function normalizeHostname(value) {
  return String(value || "").trim().toLowerCase().replace(/\.$/, "");
}

export function isLifeCirclePlatformHostname(value) {
  const hostname = normalizeHostname(value);
  return (
    !hostname ||
    ["localhost", "127.0.0.1", "::1"].includes(hostname) ||
    hostname === "life-circle.app" ||
    hostname.endsWith(".life-circle.app") ||
    hostname === "prayer-circle.app" ||
    hostname.endsWith(".prayer-circle.app") ||
    hostname.endsWith(".vercel.app")
  );
}

export function isCustomChurchHostname(value) {
  return !isLifeCirclePlatformHostname(value);
}

const RESERVED_CHURCH_SUBDOMAINS = new Set([
  "admin",
  "api",
  "app",
  "assets",
  "auth",
  "cdn",
  "mcp",
  "preview",
  "sites",
  "static",
  "www",
]);

export function churchSiteSlugFromHostname(value, baseDomain = "life-circle.app") {
  const hostname = normalizeHostname(value);
  const normalizedBase = normalizeHostname(baseDomain);
  const suffix = `.${normalizedBase}`;
  if (!hostname.endsWith(suffix) || hostname === normalizedBase) return null;
  const slug = hostname.slice(0, -suffix.length);
  if (!slug || slug.includes(".") || RESERVED_CHURCH_SUBDOMAINS.has(slug)) return null;
  return /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(slug) ? slug : null;
}

export function isChurchSiteHostname(value) {
  return Boolean(churchSiteSlugFromHostname(value)) || isCustomChurchHostname(value);
}
